import type { PatientFormData, ToothData } from './types';

export function isToothComplete(d: ToothData): boolean {
  return !!(d.kemik && d.soket && d.greft && d.hacim && d.healing);
}

export function buildVDK(p: PatientFormData, t: ToothData): string {
  return [p.cinsiyet, p.yas, p.seker, p.sigara, t.kemik, t.soket, t.greft, t.hacim, t.healing]
    .map((v) => v || '?')
    .join('');
}

export function isPatientComplete(p: PatientFormData): boolean {
  return !!(p.cinsiyet && p.yas && p.seker && p.sigara);
}

export function canSaveRecord(p: PatientFormData, configuredTeethCount: number): boolean {
  return p.patient_name.trim() !== '' && isPatientComplete(p) && configuredTeethCount > 0;
}
